/* eslint-disable */
import React, { Suspense, useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { Paper } from "@mui/material";
import VEBPlanHeader from "../../shared/enrollment/VEBPlanHeader/PlanHeader";
import { LazyBrandingActions, LazyCustomFormDialog, LazyPlanBranding } from "../../shared";

import { fetchActiveVEBPlans } from "../../../features/VEBPlans/VEBPlansThunks";
import { fetchMemberPortalInitData } from "../../../features/member/memberThunks";
import { useAppSelector } from "../../../app/hooks";
import EligiblityDialog from "./eligiblityDialogs/EligiblityDialog";
import { useHistory } from "react-router-dom";
import { VEBYearlyOpenAndCurrentEffectiveDate } from "../../../constants/VEBYearlyOpenAndCurrentDate";
import { DocRxBanner } from "../../../assets";
import VEBPreviousBenefitDisclaimerV2 from "../../shared/VEBPreviousBenefitDisclaimer/VEBPreviousBenefitDisclaimerV2";
import { VEBEnrollmentPayload } from "../../../utils/api/enrollment/enrollment";
import { generateCancerKemperWaiveEnrollmentPayload } from "../../../utils/commonFunctions/VEBEnrollment/enrollment";
import { AuthContext, EnrollmentContext, GroupOwnerContext, PaycheckContext } from "../../../contexts";
import { trackPromise } from "react-promise-tracker";
import { api } from "../../../utils/api";
import { CustomFormDialogType } from "../../../types/components/dialogProps.types";
import { BrandingPageProps } from "../../../types/components/enrollmentProps.types";
import { useGetActiveVEBPlansQuery } from "../../../features/VEBPlans/vebPlansApi";
import calculateAge from "../../../utils/commonFunctions/age";
import PopupAlert from "../../Alert/PopupAlert";
import { generateFileURL } from "../../../utils/commonFunctions/generateFileURL";
import { CheckPreviousVEBEnrollmentQueryTypes } from "../../../utils/api/enrollment/getCheckPreviousVEBEnrollment";
import { VEBEnrollmentSchema } from "../../../types/enrollment.types";

export const BrandingPageA1: React.FC<BrandingPageProps> = ({
	planName,
	planCode,
	VEBOpenEnrollment,
	changePlanProps,

	getVEBEnrollmentInitData
}) => {
	// const dispatch = useDispatch<AppDispatch>();
	const urlSearchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
	const { handleChangePlanButtonClick, buttonCaption } = changePlanProps;
	const { setCurrentEnrollment, deleteCurrentEnrollment } = useContext(EnrollmentContext);
	const { groupOwner } = useContext(GroupOwnerContext);
	const history = useHistory();
	// const { member } = useAppSelector((state) => state.memberPortal);
	const { member } = useContext(AuthContext);
	const [showPopup, setShowPopup] = useState(false);
	const { paycheck } = useContext(PaycheckContext);

	const [VEBOpenEnrollmentId, setVEBOpenEnrollmentId] = useState<string>();
	const [hasPreviousVEBEnrollment, setHasPreviousVEBEnrollment] = useState(false);
	const [waiveReason, setWaiveReason] = useState("");
	const [Plan, setCurrentPlan] = useState<any>();
	const [customFormDialogProps, setCustomFormDialogProps] = useState<CustomFormDialogType>();
	const [eligiblityDialogProps, setEligiblityDialogProps] = useState<any>({
		openDialog: false,
		handleCloseEligiblityDialog: () => setEligiblityDialogProps({ ...eligiblityDialogProps, openDialog: false }),
		eligibleDependents: [],
		ineligibleDependents: [],
		ineligibleRelationshipDependents: [],
		VEBPlanName: planName
	});
	const [isEligible, eligiblityMessage] = useState(planName);
	const [inEligible, setInEligible] = useState(false);
	const [agemessage, setAgemessage] = useState("");
	const waiveReasonRef = useRef("");

	// console.log("3131313", yearlyOpen);
	// Fetch VEB plans **once** per group
	const storedPlans = useAppSelector((state) => state.vebPlans);
	const hasOpenEnrollment = Boolean(VEBOpenEnrollment?.length);
	const stableGroupNumber = useMemo(() => member?.group_number, []);

	const { currentPlans, futurePlans, refetch } = useGetActiveVEBPlansQuery(stableGroupNumber, {
		skip: !!storedPlans.currentPlans.length,
		refetchOnMountOrArgChange: false,
		selectFromResult: ({ data }) => ({
			currentPlans: data?.currentPlans || storedPlans.currentPlans || [],
			futurePlans: data?.futurePlans || storedPlans.futurePlans || []
		})
	});
	const { yearlyOpen, openEnrollmentEndDate } = useMemo(() => {
		const planOpenEnrollment = VEBOpenEnrollment?.find(
			(openEnrollment) =>
				openEnrollment.open_enrollment.veb_plan_name === planName &&
				openEnrollment.open_enrollment.veb_plan_code === planCode
		);
		return {
			yearlyOpen: planOpenEnrollment?.open_enrollment?.type ?? null,
			openEnrollmentEndDate: planOpenEnrollment?.open_enrollment?.end_date ?? null
		};
	}, [VEBOpenEnrollment, planName, planCode]);

	const selectedPlan =
		currentPlans.find((plan) => plan.plan_name === planName && plan.plan_code === planCode) ||
		futurePlans.find((plan) => plan.plan_name === planName && plan.plan_code === planCode);

	// Set current Plan only once when plans are available
	useEffect(() => {
		if (!planName || !currentPlans.length) return;

		const newPlan = currentPlans.find((p) => p.plan_name === planName && p.plan_code === planCode);
		setCurrentPlan(newPlan || undefined);

		// optionally reset eligibility state
		setInEligible(false);
		setAgemessage("");
	}, [planName, planCode, currentPlans]);
	const checkBenifitAligibility = useCallback(() => {
		if (!paycheck) {
			return false;
		}
		let benefitAmounts: number[] = Plan?.benefit_amount?.options ?? Plan?.rider?.benefit_amount?.options ?? [0];

		if (planName === "Short Term Disability") {
			if (planName === "Short Term Disability") {
				benefitAmounts = Plan?.benefit_amount?.options ?? [];
			}

			if (benefitAmounts.length === 0) {
				return false;
			}

			let maxBenefitAmount = 0;
			// console.log("this is the ", paycheck.rate_type, paycheck.pay_frequency);
			switch (paycheck.rate_type) {
				case "FIXED": {
					if (paycheck.pay_frequency === "MONTHLY") {
						const annualSalary = paycheck.base_pay_rate * 12;

						maxBenefitAmount = Math.floor((annualSalary * 0.6) / 52 / 50) * 50;
					} else if (paycheck.pay_frequency === "WEEKLY") {
						const annualSalary = paycheck.base_pay_rate * 52;
						maxBenefitAmount = Math.floor((annualSalary * 0.6) / 52 / 50) * 50;
					}
					break;
				}

				case "HOURLY RATE": {
					if (paycheck.pay_frequency === "MONTHLY") {
						const annualSalary = paycheck.hourly_base_pay_rate * 160 * 12;
						maxBenefitAmount = Math.floor((annualSalary * 0.6) / 52 / 50) * 50;
					} else if (paycheck.pay_frequency === "WEEKLY") {
						const annualSalary = paycheck.hourly_base_pay_rate * 40 * 52;
						maxBenefitAmount = Math.floor((annualSalary * 0.6) / 52 / 50) * 50;
					}
					break;
				}
			}

			//  Eligibility check:
			// at least one benefit amount is allowed
			if (benefitAmounts[0] > maxBenefitAmount) {
				return false;
			}
		}
		// Pick correct benefit options

		return true;
	}, [paycheck, Plan, planName]);
	const checkEligibility = useCallback(async (): Promise<boolean> => {
		const employeAge = calculateAge(member?.date_of_birth, new Date());

		if (!selectedPlan) return true;

		const emp = selectedPlan?.employee_eligibility?.employee;
		if (!emp) return true;

		const minAge = Number(emp.min_age);
		const maxAge = Number(emp.max_age);
		if (planCode === "WL-ALL-2026") {
			console.log("this is the age", employeAge);
			if (employeAge < 18 || employeAge > 70) {
				const message = `You are ineligible for this plan.\n\nMinimum age for enrollment is 18 and Maximum age for enrollment is 70`;
				setInEligible(true);
				setAgemessage(message);
				return false;
			}
		} else if (planCode === "FP-ALL-2026") {
			return true;
		} else if (employeAge < minAge || employeAge > maxAge) {
			const message = `You are ineligible for this plan.\n\nMinimum age for enrollment is ${minAge} and Maximum age for enrollment is ${maxAge}`;
			setInEligible(true);
			setAgemessage(message);
			return false;
		}

		setInEligible(false);
		return true;
	}, [planCode, planName, selectedPlan, member]);

	// Handle Enroll button
	const handleEnrollButtonClick = useCallback(async () => {
		//Age eligibility (employee eligibility)
		if (!VEBOpenEnrollment?.length) {
			alert("Enrollment has not been opened for this plan. Please contact your administrator.");
			return;
		}
		const eligible = await checkEligibility();

		if (!eligible) {
			// message is already set inside checkEligibility
			setShowPopup(true);
			return;
		}

		// Benefit eligibility
		const benefitEligible = checkBenifitAligibility();

		if (!benefitEligible) {
			setAgemessage("You are not eligible for this plan based on benefit amount limits.");
			setInEligible(true);
			setShowPopup(true);
			return;
		}

		//  Proceed to enrollment
		const step = urlSearchParams.get("step");
		history.push(`?step=${step}&stage=1`);
	}, [checkEligibility, checkBenifitAligibility, VEBOpenEnrollment, urlSearchParams, history]);

	// Handle Waive Enrollment
	const handleWaiveEnrollment = useCallback(async () => {
		if (!member || !VEBOpenEnrollment || !isEligible || !Plan) return;

		const planOpenEnrollment = VEBOpenEnrollment.find(
			(openEnrollment) =>
				openEnrollment.open_enrollment.veb_plan_name === planName &&
				openEnrollment.open_enrollment.veb_plan_code === planCode
		);
		// console.log("this is working from the waive 2");

		const reason = waiveReasonRef.current;

		const openEnrollmentId = String(planOpenEnrollment?.VEB_open_enrollment_id || "");
		setVEBOpenEnrollmentId(openEnrollmentId);

		const { VEBEnrollmentCommonDetails, VEBEnrollmentStandardDetails } = generateCancerKemperWaiveEnrollmentPayload(
			Plan,
			Plan.plan_name,
			Plan.plan_name,
			null,
			groupOwner,
			member,
			reason,
			openEnrollmentId,
			false
		);
		// console.log("this is working from the waive VEBEnrollmentCommonDetails", VEBEnrollmentCommonDetails);

		const VEBEnrollmentPayload: VEBEnrollmentPayload = {
			standard_details: VEBEnrollmentStandardDetails,
			common_details: VEBEnrollmentCommonDetails,
			isRider: false
		};
		console.log("this is the VEBEnrollmentPayload", VEBEnrollmentPayload);
		const response = await trackPromise(api.enrollment.addVEBEnrollment(VEBEnrollmentPayload));
		console.log("response", response);
		if (response) {
			deleteCurrentEnrollment();
			getVEBEnrollmentInitData();
			const step = urlSearchParams.get("step");
			const from = urlSearchParams.get("from");
			if (from === "Critical Illness") {
				alert("Successfully waived  plan");
				history.push(`?step=${from}&stage=1`);
			} else {
				history.push(`?step=${step}&stage=2`);
			}
		}
	}, [
		member,
		VEBOpenEnrollment,
		Plan,
		planName,
		planCode,
		groupOwner,
		waiveReason,
		urlSearchParams,
		deleteCurrentEnrollment,
		getVEBEnrollmentInitData,
		history
	]);

	// Handle Waive Button Dialog
	const handleWaiveButtonClick = useCallback(async () => {
		if (!VEBOpenEnrollment?.length) {
			alert("Enrollment has not been opened for this plan. Please contact your administrator.");
			return;
		}
		const benefitEligible = checkBenifitAligibility();
		if (!benefitEligible) {
			setAgemessage("You are not eligible for this plan based on benefit amount limits.");
			setInEligible(true);
			setShowPopup(true);
			return;
		}
		setCustomFormDialogProps({
			...customFormDialogProps,
			openDialog: true,
			title: "Are you sure want to waive this enrollment?",
			textfields: [
				{
					label: "Waive Reason",
					value: waiveReason,
					onChange: (e) => {
						waiveReasonRef.current = e.target.value;
						setWaiveReason(e.target.value);
					},

					placeholder: "Enter your reason for waive"
				}
			],
			actions: [
				{
					label: "Cancel",
					callback: () =>
						setCustomFormDialogProps(Object.assign({}, customFormDialogProps, { openDialog: false }))
				},
				{
					label: "Yes",
					callback: () => {
						setCustomFormDialogProps(
							Object.assign({}, customFormDialogProps, {
								openDialog: false
							})
						);

						handleWaiveEnrollment();
					}
				}
			]
		});
	}, [customFormDialogProps, handleWaiveEnrollment, waiveReason]);
	////console.log("handlebraning", handleChangePlanButtonClick, buttonCaption);

	//console.log("selectedPlan", selectedPlan, Plan, planName);

	// console.log("open enrollment", VEBOpenEnrollment);

	const getCheckPreviousVEBEnrollment = useCallback(
		async (group_number: number, SSN: string) => {
			const checkPreviousPayload: CheckPreviousVEBEnrollmentQueryTypes = {
				group_number,
				insured_SSN: SSN
			};

			const response: VEBEnrollmentSchema[] = await trackPromise(
				api.enrollment.getCheckPreviousVEBEnrollment(checkPreviousPayload)
			);

			if (response) {
				const thisPlansEnrollments = response.some((eachPlan) => eachPlan.plan_name === planName);

				// const hasActive = thisPlansEnrollments.some((eachPlan) => eachPlan.enrollment_status === "ACTIVE");

				setHasPreviousVEBEnrollment(thisPlansEnrollments);
			}
		},
		[planName]
	);

	const currentPlansOpened =
		VEBOpenEnrollment?.find((enrollment) => enrollment.open_enrollment.veb_plan_name === planName) || null;

	useEffect(() => {
		if (selectedPlan && member) {
			checkEligibility();
		}
	}, [selectedPlan, member, planName]);
	useEffect(() => {
		if (member) getCheckPreviousVEBEnrollment(member.group_number, member.SSN);
	}, [getCheckPreviousVEBEnrollment, member]);
	return (
		<div className="paper-form-container">
			<Suspense fallback={<div />}>
				{customFormDialogProps && <LazyCustomFormDialog customFormDialogProps={customFormDialogProps} />}
				<EligiblityDialog eligiblityDialogProps={eligiblityDialogProps} />
			</Suspense>

			<Paper className="theme-border-radius paper-container" elevation={1}>
				{/*  VEBPlanHeader — check by plan code */}
				{planName === "Family Protection" ? (
					<VEBPlanHeader
						planName={"Term Life To Age 121"}
						effectiveDate={
							VEBYearlyOpenAndCurrentEffectiveDate.veb_current_effective_date_MMDDYYYY || "N/A"
						}
						planCode={selectedPlan?.plan_code || "No Plan is Opened"}
					/>
				) : (
					<VEBPlanHeader
						planName={planName || "No Plan"}
						effectiveDate={
							VEBYearlyOpenAndCurrentEffectiveDate.veb_current_effective_date_MMDDYYYY || "N/A"
						}
						planCode={selectedPlan?.plan_code || "No Plan is Opened"}
					/>
				)}

				<div className="theme-plan-section-margin" />
				{/*  Branding Section with Skeleton */}
				{!selectedPlan ? (
					//  CASE 1: Plan not loaded yet — show full skeleton

					<div style={{ padding: "10px" }}>
						<style>{`
                    @keyframes pulse {
                        0%   { opacity: 1; }
                        50%  { opacity: 0.4; }
                        100% { opacity: 1; }
                    }
                `}</style>

						{/* Logo Skeleton */}
						<div
							style={{
								width: "160px",
								height: "56px",
								backgroundColor: "#e0e0e0",
								borderRadius: "4px",
								marginLeft: "10px",
								animation: "pulse 1.5s infinite"
							}}
						/>

						<div style={{ display: "flex", alignItems: "flex-start", gap: "20px", marginTop: "10px" }}>
							{/* Image Skeleton */}
							<div
								style={{
									width: "360px",
									height: "200px",
									backgroundColor: "#e0e0e0",
									borderRadius: "8px",
									animation: "pulse 1.5s infinite"
								}}
							/>

							{/* Text Skeleton */}
							<div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "8px" }}>
								<div
									style={{
										width: "90%",
										height: "12px",
										backgroundColor: "#e0e0e0",
										borderRadius: "4px",
										animation: "pulse 1.5s infinite"
									}}
								/>
								<div
									style={{
										width: "80%",
										height: "12px",
										backgroundColor: "#e0e0e0",
										borderRadius: "4px",
										animation: "pulse 1.5s infinite"
									}}
								/>
								<div
									style={{
										width: "85%",
										height: "12px",
										backgroundColor: "#e0e0e0",
										borderRadius: "4px",
										animation: "pulse 1.5s infinite"
									}}
								/>
								<div
									style={{
										width: "70%",
										height: "12px",
										backgroundColor: "#e0e0e0",
										borderRadius: "4px",
										animation: "pulse 1.5s infinite"
									}}
								/>
								<div
									style={{
										width: "75%",
										height: "12px",
										backgroundColor: "#e0e0e0",
										borderRadius: "4px",
										animation: "pulse 1.5s infinite"
									}}
								/>
								<div
									style={{
										width: "60%",
										height: "12px",
										backgroundColor: "#e0e0e0",
										borderRadius: "4px",
										animation: "pulse 1.5s infinite"
									}}
								/>
							</div>
						</div>
					</div>
				) : selectedPlan?.planDesign?.branding_design?.image && selectedPlan.planDesign.branding_design.logo ? (
					// ✅ CASE 2: Plan has branding data — show actual content
					<div>
						{/* Logo */}
						<div style={{ width: "160px", height: "56px", overflow: "hidden", marginLeft: "10px" }}>
							<LazyPlanBranding
								imgSrc={
									selectedPlan?.planDesign?.branding_design?.image
										? generateFileURL(selectedPlan.planDesign.branding_design.logo)
										: DocRxBanner
								}
							/>
						</div>

						<div style={{ display: "flex", alignItems: "flex-start", gap: "20px" }}>
							{/* LEFT — Branding Image */}
							<div
								style={{
									width: "360px",
									height: "200px",
									overflow: "hidden",
									borderRadius: "8px",
									boxShadow: "0 4px 14px rgba(0,0,0,0.35)"
								}}
							>
								{selectedPlan?.planDesign?.branding_design?.image ? (
									<LazyPlanBranding
										imgSrc={generateFileURL(selectedPlan.planDesign.branding_design.image)}
									/>
								) : (
									<LazyPlanBranding imgSrc={DocRxBanner} />
								)}
							</div>

							{/* RIGHT — Text or Text Skeleton */}
							<div
								style={{
									flex: 1,
									display: "flex",
									alignItems: "center",
									justifyContent: "flex-start",
									marginTop: "-25px"
								}}
							>
								{selectedPlan?.planDesign?.branding_design?.textual_details ? (
									//  Has text — show actual content
									<div
										dangerouslySetInnerHTML={{
											__html: `
                                        <style>
                                            .inline-limit {
                                                max-height: 340px;
                                                max-width: 550px;
                                                overflow: hidden;
                                                font-size: 11px !important;
                                                line-height: 1.3 !important;
                                            }
                                            .inline-limit * {
                                                font-size: 11px !important;
                                                line-height: 1.3 !important;
                                            }
                                            .inline-limit p {
                                                margin: 3px 0 !important;
                                            }
                                            .inline-limit h1,
                                            .inline-limit h2,
                                            .inline-limit h3 {
                                                font-size: 13px !important;
                                                margin: 4px 0 !important;
                                            }
                                        </style>
                                        <div class="inline-limit">
                                            ${selectedPlan.planDesign.branding_design.textual_details}
                                        </div>
                                    `
										}}
									/>
								) : (
									// No text — show text skeleton
									<div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "8px" }}>
										<style>{`
                                    @keyframes pulse {
                                        0%   { opacity: 1; }
                                        50%  { opacity: 0.4; }
                                        100% { opacity: 1; }
                                    }
                                `}</style>
										<div
											style={{
												width: "90%",
												height: "12px",
												backgroundColor: "#e0e0e0",
												borderRadius: "4px",
												animation: "pulse 1.5s infinite"
											}}
										/>
										<div
											style={{
												width: "80%",
												height: "12px",
												backgroundColor: "#e0e0e0",
												borderRadius: "4px",
												animation: "pulse 1.5s infinite"
											}}
										/>
										<div
											style={{
												width: "85%",
												height: "12px",
												backgroundColor: "#e0e0e0",
												borderRadius: "4px",
												animation: "pulse 1.5s infinite"
											}}
										/>
										<div
											style={{
												width: "70%",
												height: "12px",
												backgroundColor: "#e0e0e0",
												borderRadius: "4px",
												animation: "pulse 1.5s infinite"
											}}
										/>
									</div>
								)}
							</div>
						</div>
					</div>
				) : (
					// CASE 3: No branding data — show full skeleton
					<div style={{ padding: "10px" }}>
						<style>{`
                    @keyframes pulse {
                        0%   { opacity: 1; }
                        50%  { opacity: 0.4; }
                        100% { opacity: 1; }
                    }
                `}</style>

						{/* Logo Skeleton */}
						<div
							style={{
								width: "160px",
								height: "56px",
								backgroundColor: "#e0e0e0",
								borderRadius: "4px",
								marginLeft: "10px",
								animation: "pulse 1.5s infinite"
							}}
						/>

						<div style={{ display: "flex", alignItems: "flex-start", gap: "20px", marginTop: "10px" }}>
							{/* Image Skeleton */}
							<div
								style={{
									width: "360px",
									height: "200px",
									backgroundColor: "#e0e0e0",
									borderRadius: "8px",
									animation: "pulse 1.5s infinite"
								}}
							/>

							{/* Text Skeleton */}
							<div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "8px" }}>
								<div
									style={{
										width: "90%",
										height: "12px",
										backgroundColor: "#e0e0e0",
										borderRadius: "4px",
										animation: "pulse 1.5s infinite"
									}}
								/>
								<div
									style={{
										width: "80%",
										height: "12px",
										backgroundColor: "#e0e0e0",
										borderRadius: "4px",
										animation: "pulse 1.5s infinite"
									}}
								/>
								<div
									style={{
										width: "85%",
										height: "12px",
										backgroundColor: "#e0e0e0",
										borderRadius: "4px",
										animation: "pulse 1.5s infinite"
									}}
								/>
								<div
									style={{
										width: "70%",
										height: "12px",
										backgroundColor: "#e0e0e0",
										borderRadius: "4px",
										animation: "pulse 1.5s infinite"
									}}
								/>
								<div
									style={{
										width: "75%",
										height: "12px",
										backgroundColor: "#e0e0e0",
										borderRadius: "4px",
										animation: "pulse 1.5s infinite"
									}}
								/>
								<div
									style={{
										width: "60%",
										height: "12px",
										backgroundColor: "#e0e0e0",
										borderRadius: "4px",
										animation: "pulse 1.5s infinite"
									}}
								/>
							</div>
						</div>
					</div>
				)}
				{hasPreviousVEBEnrollment && <VEBPreviousBenefitDisclaimerV2 />}
				{inEligible && <PopupAlert open={showPopup} message={agemessage} onClose={() => setShowPopup(false)} />}
				<LazyBrandingActions
					waiveButtonCallback={handleWaiveButtonClick}
					enrollButtonCallback={handleEnrollButtonClick}
					planNameIndicator={planName}
					handleChangePlanButtonClick={handleChangePlanButtonClick}
					buttonCaption={buttonCaption}
					disableChangePlan={!hasOpenEnrollment}
				/>
			</Paper>
		</div>
	);
};
